import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function BookingCancel() {
  return (
    <main data-testid="booking-cancel-page" className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-10">
          <img src={BRAND.logoUrl} alt="MHJ" className="h-10 w-10 object-contain" />
          <span className="font-display font-extrabold text-sm tracking-tight">MHJ PRESTIGE</span>
        </Link>
        <div className="inline-flex items-center justify-center w-16 h-16 border border-white/20 mx-auto mb-6">
          <AlertCircle className="w-8 h-8 text-white" />
        </div>
        <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500 font-bold">
          Payment cancelled
        </div>
        <h1 className="font-display font-extrabold text-3xl md:text-5xl mt-4">
          No payment taken.
        </h1>
        <p className="text-zinc-400 mt-4">
          You cancelled before completing the booking. No charge has been made.
          You can try again — or give us a call on {BRAND.phone}.
        </p>
        <div className="flex gap-3 justify-center mt-10 flex-wrap">
          <Link to="/quote" className="btn-primary" data-testid="cancel-retry">
            Try again
          </Link>
          <Link to="/" className="btn-ghost" data-testid="cancel-home">
            Return home
          </Link>
        </div>
      </div>
    </main>
  );
}
